import { accountService } from 'services';

export function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    let error;
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        accountService.logout();
        error = {
          message: 'Unauthorized: Username or password is invalid.',
          status: response.status
        }
      }
      else if (response.status === 404) {
        // auto logout if 401 response returned from api
        error = {
          message: 'We couldnt find what you are looking for',
          status: response.status
        }
      }

      else if (response.status === 500) {
        // auto logout if 401 response returned from api
        error = {
          message: 'We experience some error with your request, please contact the administrator',
          status: response.status
        }
      }

      else {
        error = {
          data: data.data || data.error || data.message || response.statusText,
          errors: data.errors && data.errors.errors ? data.errors.errors : undefined,
          fields: data.errors && data.errors.fields ? data.errors.fields : undefined,
          message: data.error || data.message,
          status: response.status
        }
      }


      return Promise.reject(error);
    }
    return data;
  });
}
